import { render, staticRenderFns } from "./SithMomPjBCInfo.vue?vue&type=template&id=69d5aca0&scoped=true&"
import script from "./SithMomPjBCInfo.vue?vue&type=script&lang=js&"
export * from "./SithMomPjBCInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d5aca0",
  null
  
)

export default component.exports